import SearchIcon from 'assets/svg/search/search.svg'
import { MOBILE_WEB_URL } from 'common/constants'
import theme from 'common/theme'
import highlighter from 'lib/highlighter'
import { ISuggestionItem } from 'services/Product/stores/models/SearchSuggestionModel/interface'
import styled from 'styled-components'

const HighlitedText = styled.p`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const StyledListItemResult = styled.li`
  background-color: ${(props) =>
    props.isHighlited ? theme.colors.grayLighter : ''};
  display: flex;
`

function Tender({
  suggestionItem,
  keywords,
  isHighlited,
}: ISuggestionItem): JSX.Element {
  const handleItemClick = () => {
    window.location.assign(
      `${MOBILE_WEB_URL}/tender/requests/${suggestionItem.id}`,
    )
  }

  return (
    <StyledListItemResult
      onClick={handleItemClick}
      isHighlited={isHighlited}
      data-testid="tender-item"
    >
      <SearchIcon width="13" height="13" />
      <HighlitedText
        dangerouslySetInnerHTML={{
          __html: highlighter(suggestionItem.description, keywords),
        }}
        data-testid="tender-item-text"
      />
    </StyledListItemResult>
  )
}

export default Tender
